import {AccountBriefRecord, AccountBriefRecords} from "../../../../types/AccountBriefRecord";
import {PortfolioType} from "../../../../../portfolio/models/Portfolio";

export type AccountDropDownViewModels = ReadonlyArray<AccountDropDownViewModel>;

export interface AccountDropDownViewModel {
    readonly id: number;
    readonly name: string;
    readonly number: string;
    readonly portfolioType: PortfolioType;
    readonly selected: boolean;
}

export function buildModels(accounts: AccountBriefRecords,
                            selected: AccountBriefRecord | null): AccountDropDownViewModels {
    return accounts.map((acc) => buildModel(acc, selected));
}

export function buildModel(account: AccountBriefRecord,
                           selectedAccount: AccountBriefRecord | null): AccountDropDownViewModel {
    const selected = (selectedAccount != null) && (account.id === selectedAccount.id);
    return {
        id: account.id,
        name: account.name,
        number: account.number,
        portfolioType: account.portfolioType,
        selected
    };
}
